import type { FieldBreakPointConfigProtocol } from '@lighthouse/core'
import { useMemo } from 'react'

import { useApplicationContext } from '../../../contexts'
import { useMediaQueryRemBase } from '../../../hooks'

export function useFieldInputFont(breakPoint?: FieldBreakPointConfigProtocol) {
    const { isBuilder } = useApplicationContext()
    const rootFontSize = useMediaQueryRemBase()

    const customFontSize = useMemo(() => {
        const fontSize = breakPoint?.font?.fontSize
        if (!fontSize || !fontSize.size) {
            return undefined
        }
        if (fontSize.unit === 'rem' && isBuilder) {
            return `${rootFontSize * (fontSize.size || 0)}px`
        }
        return `${fontSize.size}${fontSize.unit || 'px'}`
    }, [breakPoint?.font?.fontSize, isBuilder, rootFontSize])

    const customFontFamily = breakPoint?.font?.fontFamily
    const customFontWeight = breakPoint?.font?.fontWeight

    return { customFontSize, customFontFamily, customFontWeight }
}
